module.exports = __webpack_public_path__ + "img/hugo.cd143ad0.jpg";